import { appProfileDaysG4Tr } from './golf4App.tr.js';
// Turks (tr-TR), profileApp: zelfde vorm als profileApp.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm). Woordkeus: gewoontes, nooit nationaliteit;
// islamitische termen in hun gewone Turkse vorm (Ramazan Bayramı, Kurban Bayramı, abdest).
// consent.version blijft gelijk aan nl (PROFILE_CONSENT_VERSION); de hash dekt alleen nl en en.
export const appProfileTr = {
    title: 'Ailemize uygun olanlar',
    intro: 'Ailene uygun olanı seç, listeler böylece sadeleşir. Hepsi isteğe bağlı.',
    privacyLine: 'Bunu sadece ebeveynler görebilir ve değiştirebilir. Bağlı akrabalar asla görmez.',
    privacyLink: 'Gizlilik bildirimi',
    privacyPage: {
        title: 'Gizlilik bildirimi',
        back: 'Uygulamaya dön',
        intro: '"Ailemize uygun olanlar" hakkında: mutfak, inanç, yemek ve özel günler. Kısa ve anlaşılır.',
        sections: [
            {
                title: 'Ne için',
                body: 'Seçimlerini sadece hangi seçenekleri göreceğini belirlemek için kullanırız: şablonlar, simgeler, tarifler ve özel günler. Reklam için değil, senin hakkında profil çıkarmak için değil, paylaşmak için de değil.',
            },
            {
                title: 'Hangi veriler',
                body: 'Mutfaklar ve gelenekler, inanç (seçtiğin ibadetler ve mezhep dahil), beslenme kuralları (helal ya da vejetaryen gibi), aile üyesi başına farklılıklar, bir tarifte "başka bir şey yiyor" bilgisi ve açtığın özel günler. İnanç, helal ve koşer, bazen de bir gelenek, özel nitelikli kişisel verilerdir (AVG/GDPR madde 9).',
            },
            {
                title: 'Hukuki dayanak',
                body: 'Açık rızan (AVG/GDPR madde 9 fıkra 2 bent a). Bir ebeveyn bu rızayı kendisi ve 16 yaşından küçük çocukları için verir; kendi hesabı olan bir yetişkin, kendi farklılığı için rızayı kendisi verebilir. Hepsi isteğe bağlı: rıza olmadan da uygulama normal çalışır.',
            },
            {
                title: 'Kim görür',
                body: 'Seçimlerin kendisini sadece ailendeki ebeveynler görür. Tablet ve uygulama sadece uygun olanı gösterir; yemekte kimin neyi yemediğini söyleriz. Bağlı akrabalar, misafirler, paylaşım bağlantıları, takvim akışları, hata mesajları ve kayıt dosyaları seçimleri asla almaz. Özel günler bir takvim dışa aktarımına sadece bunu ayrıca açarsan girer.',
            },
            {
                title: 'Ne kadar süre',
                body: 'Rıza geçerli olduğu sürece. Rızayı geri çekmek seçimleri hemen siler; yedeklerden 90 gün içinde kaybolurlar. Rızanın kanıtını (kim, ne zaman, hangi metin; içerik olmadan) geri çekmeden sonra 5 yıla kadar ya da aile silinene kadar saklarız.',
            },
            {
                title: 'Hakların',
                body: 'Verilerini Ayarlar · Ailemize uygun olanlar bölümünde görebilir ve değiştirebilir, Ayarlar · Verileri indir bölümünden indirebilir (her ebeveyn kendi verilerini, yönetici hepsini), rızanı geri çekebilir (bu her şeyi siler) ve silinmesini isteyebilirsin. Bir konuda aynı fikirde değilsen Hollanda Kişisel Verileri Koruma Kurumuna (Autoriteit Persoonsgegevens) şikâyette bulunabilirsin.',
            },
            {
                title: 'Sorumlu ve iletişim',
                body: 'Bu verilerden AMUMIN B.V. sorumludur. Kendi verilerini Ayarlar bölümünden kendin indirirsin. Soruların ya da silme istekleri için AMUMIN B.V. ile iletişime geç; aşağıdaki sabit gizlilik adresi henüz yokken aile hesabının yöneticisi aracılığıyla. Başka aileler kaydolmadan önce buraya sabit bir gizlilik adresi ve Ticaret Odası (KvK) bilgileri eklenecek.',
            },
        ],
    },
    settingsBody: 'Mutfak, inanç, yemek ve özel günler',
    saveBar: 'Değişiklikleri kaydet',
    invite: {
        title: 'Ailene neler uygun?',
        body: 'Mutfak, inanç ve yemeği seç; böylece daha çok sana uygun olanı görürsün. Zorunlu değil.',
        start: 'Ayarla',
        later: 'Şimdi değil',
        never: 'Hayır, teşekkürler',
    },
    otherParent: {
        title: 'Ailene uygun olanlar',
        body: '{name}, ailene uygun olanları ayarladı: {what}. Bu senin için de doğru mu?',
        titleNeutral: 'Size uygun olanlar',
        bodyNeutral: '{name}, size uygun olanları ayarladı: {what}. Bu senin için de doğru mu?',
        view: 'Göz at',
    },
    wizard: {
        title: 'Sana neler uygun?',
        body: 'Sadece istediğini seç; gerisi boş kalabilir. Her şeyi sonra değiştirebilirsin.',
        skip: 'Atla',
        skipQuestion: 'Bu soruyu atla',
        next: 'İleri',
        done: 'Bitti',
        save: 'Kaydet',
        nothingSaved: 'Hiçbir şey seçmedin, bu yüzden hiçbir şey kaydetmiyoruz.',
        step: '{n}/{total}',
        question: '{step} · soru {n}/{total}',
    },
    traditions: {
        title: 'Mutfak ve gelenekler',
        body: 'Hangi mutfaklar ve gelenekler ailene ait? Birden fazla seçebilirsin.',
        hint: 'Bu, milliyetle değil alışkanlıklarla ilgili. Sadece ailenin hangi mutfakları sevdiğini hatırlarız. Bunu tariflerin sırası ve bayramları önermek için kullanırız.',
        labels: {
            dutch: 'Hollanda',
            turkish: 'Türk',
            moroccan: 'Fas',
            surinamese: 'Surinam',
            antillean: 'Antiller',
            indonesian: 'Endonezya',
            moluccan: 'Molukka',
            italian: 'İtalyan',
            polish: 'Polonya',
            middle_eastern: 'Orta Doğu',
            other: 'Diğer',
        },
        otherKitchens: {
            title: 'Ailece hangi mutfakları seviyorsunuz?',
            more: 'Daha fazla mutfak',
        },
    },
    suggestion: {
        title: 'Bu sana uygun mu?',
        body: 'Seçim senin. Her zaman değiştirebilirsin.',
        accept: 'Evet, kullan',
        decline: 'Kendim seçeyim',
        days: 'Eklenebilecek başka günler de var: {sets}. Onları Özel günler bölümünden kendin açarsın.',
    },
    faiths: {
        title: 'İnanç',
        body: 'Böylece uygun seçenekleri görürsün. Bayramları sonra kendin açabilirsin.',
        none: 'İnanç yok',
        shows: 'O zaman şunları görürsün: {list}',
        /** Golf 6b: gewoontes bij het gekozen geloof, optioneel (niets voorgevinkt). */
        madhab: {
            title: 'Hangi mezhebi takip ediyorsunuz?',
            body: 'Böylece ikindi vaktini de doğru ayarlıyoruz. Bunu her zaman değiştirebilirsin.',
            hint: 'Diyanet ve Milli Görüş gibi Türk camileri Hanefi mezhebini takip eder. Fas kökenli camiler çoğunlukla Maliki mezhebini takip eder.',
            unknown: 'Bilmiyorum / geç',
            labels: { hanafi: 'Hanefi', shafii: 'Şafii', maliki: 'Maliki', hanbali: 'Hanbeli' },
        },
        practicesTitle: 'Ailece neler yapıyorsunuz?',
        practicesHint: 'Ailece yaptıklarınızı işaretle. Sadece bunları randevu, iş veya simge olarak hazırlarız. Hiçbirini işaretlememek de olur.',
        openHint: 'Hiçbir şey seçmezsen Namaz ve Cami dersi önerilerde görünmez (aramada yine bulunur). Görmek istiyorsan ailenin inancını seç.',
        labels: {
            islam: 'İslam',
            christianity: 'Hristiyanlık',
            judaism: 'Yahudilik',
            hinduism: 'Hinduizm',
            other: 'Başka bir inanç',
        },
    },
    food: {
        title: 'Yemek',
        body: 'Buna uymayan tarifleri ve alışveriş ürünlerini gözden kaldırırız. Arama ya da "Hepsini göster" ile onları her zaman bulursun.',
        labels: {
            halal: 'Helal',
            no_pork: 'Domuz eti yok',
            no_beef: 'Sığır eti yok',
            vegetarian: 'Vejetaryen',
            vegan: 'Vegan',
            kosher: 'Koşer',
            no_alcohol: 'Alkol yok',
        },
    },
    days: {
        ...appProfileDaysG4Tr,
        title: 'Takvimde özel günler',
        optional: 'isteğe bağlı',
        body: 'Takvimde ek günler ister misin? Hollanda resmî tatilleri açık; ek setlerin hepsi kapalı. Görmek istediklerini aç.',
        perDay: 'Gün gün seç',
        more: 'Daha fazla özel gün',
        next: 'Sıradaki: {dates}',
        noDates: 'Bu yılın tarihleri henüz belli değil.',
        expected: '(tahmini)',
        expectedNote: 'Kesin gün bir gün kayabilir.',
        expectedTag: 'tahmini',
        sheet: {
            expected: 'Bu gün henüz kesin değil.',
            when: '{dates} gününe denk gelir.',
            confirm: 'Günü onayla',
            confirmHint: 'Ailemize uygun olanlar, Özel günler bölümünde onayla ya da kaydır.',
        },
        eveBefore: 'Bir önceki akşam gün batımında başlar.',
        eitherOr: '{a} ya da {b}',
        nl: {
            title: 'Hollanda resmî tatilleri',
            note: 'Herkes için. Varsayılan olarak açık.',
            days: {
                nieuwjaarsdag: 'Yılbaşı',
                goede_vrijdag: 'Kutsal Cuma',
                pasen: 'Paskalya',
                koningsdag: 'Kral Günü',
                bevrijdingsdag: 'Kurtuluş Günü',
                hemelvaartsdag: 'Göğe Yükseliş Günü',
                pinksteren: 'Pentekost',
                kerstmis: 'Noel',
                moederdag: 'Anneler Günü',
                vaderdag: 'Babalar Günü',
                sinterklaas: 'Sinterklaas',
                oudejaarsavond: 'Yılbaşı gecesi',
            },
        },
        dayNames: {
            ramadan_start: 'Ramazan başlangıcı',
            ramadan_end: 'Ramazan’ın son günü',
            eid_al_fitr: 'Ramazan Bayramı',
            eid_al_adha: 'Kurban Bayramı',
            islamic_new_year: 'Hicri Yılbaşı',
            mawlid: 'Mevlid Kandili',
        },
        tradition: {
            title: 'Hangi takvimi takip ediyorsunuz?',
            body: 'Camiler bayram günlerini hep aynı şekilde belirlemez.',
            options: {
                diyanet: 'Türkiye (Diyanet, sabit takvim)',
                saudi: 'Suudi Arabistan (hilal gözlemi)',
                morocco: 'Fas (hilal gözlemi, bir önceki akşam kesinleşir)',
                own_mosque: 'Kendi camimiz (±1 gün)',
            },
            hints: {
                diyanet: 'Tarihler yıllar öncesinden bellidir.',
                saudi: 'Bir önceki akşamki duyuruya kadar iki olası gün görürsün.',
                morocco: 'Çoğu zaman Suudi Arabistan’dan bir gün sonradır. Duyuruya kadar iki olası gün görürsün.',
                own_mosque: 'Sabit takvimi görürsün. Camin bir gün önce ya da sonra seçerse burada düzelt.',
            },
            defaultNote: 'Varsayılan: Diyanet’in sabit takvimi. Caminin takip ettiğini seçebilirsin.',
            confirmTitle: 'Belli oldu mu?',
            confirmBody: 'Caminin seçtiği güne dokun. Böylece takvimde kesinleşir.',
            unknown: 'Henüz belli değil',
            confirmedNote: 'Takvimde kesin.',
        },
        sets: {
            tr_national: 'Türkiye resmî bayramları',
            keti_koti: 'Keti Koti',
            indies_remembrance: '15 Ağustos anması',
            id_independence: 'Endonezya Bağımsızlık Günü',
            it_national: 'İtalya resmî tatilleri',
            pl_national: 'Polonya resmî tatilleri',
            islamic: 'Dinî bayramlar ve günler',
            christian: 'Hristiyan günleri',
            jewish: 'Yahudi bayramları',
            hindu: 'Hindu bayramları',
        },
        ics: {
            toggle: 'Özel günler takvim dışa aktarımlarında da olsun',
            warning: 'Takvim uygulaman (örneğin Google) bu günleri görür.',
        },
    },
    flags: {
        pork: 'domuz eti',
        beef: 'sığır eti',
        meat: 'et',
        fish: 'balık',
        shellfish: 'kabuklu deniz ürünleri',
        dairy: 'süt ürünleri',
        egg: 'yumurta',
        honey: 'bal',
        gelatin: 'jelatin',
        alcohol: 'alkol',
    },
    kitchens: {
        dutch: 'Hollanda',
        turkish: 'Türk',
        moroccan: 'Fas',
        surinamese: 'Surinam',
        antillean: 'Antiller',
        indonesian: 'Endonezya',
        moluccan: 'Molukka',
        italian: 'İtalyan',
        polish: 'Polonya',
        middle_eastern: 'Orta Doğu',
        chinese: 'Çin',
        indian: 'Hint',
        mexican: 'Meksika',
        greek: 'Yunan',
        west_african: 'Batı Afrika',
        central_african: 'Orta Afrika',
        east_african: 'Doğu Afrika',
        american: 'Amerikan',
    },
    member: {
        follows: 'Aileyi takip ediyor',
        differs: 'Aileden farklı',
        reset: 'Yeniden aileyi takip et',
        plus: 'Aileyi takip ediyor, artı {what}',
        minus: 'Aileyi takip ediyor, {what} hariç',
        faithDiffers: 'İnanç: {what}',
        notPossible: 'Bunu {name} için ayrıca ayarlayamazsın. Bu, ancak {name} kendi hesabıyla rıza verirse mümkün. O zamana kadar {name} aileyi takip eder.',
        askSelf: 'Bunu kendisinin ayarlaması için {name} ile konuş.',
        shareLink: 'Bağlantıyı paylaş',
    },
    consent: {
        version: '2026-09-25.4',
        title: 'İzin veriyor musun?',
        text: 'İnanç, beslenme kuralları ve mutfaklar hassas veriler olabilir. Onları sadece hangi seçenekleri göreceğini belirlemek için kullanırız.\nBunu sadece ebeveynler görebilir ve değiştirebilir. Tablet ve uygulama uygun olanı gösterir; yemekte kimin neyi yemediğini söyleriz.\nBazı seçimlerle panoya ek bölümler koyabilirsin. O zaman odadaki herkes onları görür.\nBağlı akrabalarla ya da paylaşılan listelerde hiçbir şey paylaşmayız. Özel günler takvime ya da bir takvim dışa aktarımına sadece bunu kendin açarsan girer.\nİzni her zaman geri çekebilirsin; bu her şeyi hemen siler. Yedeklerden 90 gün içinde kaybolur.\nBu verilerden AMUMIN B.V. sorumludur. Hakların gizlilik bildiriminde yazılı.',
        check: 'Kendim ve 16 yaşından küçük çocuklarım için izin veriyorum.',
        given: 'İzni veren: {name}, {date}',
        /** Fijnslijpen: zonder bekende naam (geen "door  op"). */
        givenAt: 'İzin verildi: {date}',
        renew: 'Açıklama değişti. Lütfen okuyup yeniden izin ver.',
        withdraw: 'İzni geri çek ve sil',
        withdrawConfirm: 'Ailenin mutfaklarını, inancını, beslenme kurallarını ve özel günlerini sileriz. Ardından yine her şeyi görürsün. Devam edilsin mi?',
        withdrawn: 'Silindi. Yine her şeyi görüyorsun.',
    },
    selfConsent: {
        title: 'Bu senin için doğru mu?',
        text: 'Neye inandığını ya da ne yediğini kendin için ayarlıyorsun. Bunu sadece hangi seçenekleri göreceğini belirlemek için kullanırız; yemekte bir şey sana uymuyorsa adını söyleriz. Bunu sadece sen ve bu ailedeki ebeveynler görür. İzni geri çekmek hemen siler.',
        check: 'Kendim için izin veriyorum.',
        withdraw: 'İznimi geri çek',
    },
    daySetsInline: {
        tr_national: 'Türkiye resmî bayramları',
        keti_koti: 'Keti Koti',
        indies_remembrance: '15 Ağustos anması',
        id_independence: 'Endonezya Bağımsızlık Günü',
        it_national: 'İtalya resmî tatilleri',
        pl_national: 'Polonya resmî tatilleri',
        islamic: 'dinî bayramlar ve günler',
        christian: 'Hristiyan günleri',
        jewish: 'Yahudi bayramları',
        hindu: 'Hindu bayramları',
    },
    hidden: {
        showAll: 'Hepsini göster',
        showLess: 'Daha az göster',
        count: { one: '{count} seçenek gizli', other: '{count} seçenek gizli' },
        groupFood: 'Gizlendi, çünkü {rules}',
        groupFaith: 'Başka bir inanca ait',
        groupNotChosen: '{what} seçilirse görünür',
        groupFaithOpen: 'İnanç sorusunda bir seçim yapana kadar gizli',
        /** Golf 6b: geloof gekozen, gewoonte niet aangevinkt. */
        groupPractice: 'İnanç bölümünde işaretlenmedi',
        practice: '{practice} inanç bölümünde işaretlenmediği için gizli. Ayarlar’dan değiştirebilirsin.',
        change: 'Değiştir',
        faith: 'Şuna ait: {faiths}. Sen başka bir şey seçtin.',
        faithNone: 'İnanç sorusunda "İnanç yok" seçtiğin için gizlendi. Ayarlar’dan değiştirebilirsin.',
        notChosen: 'Ayarlar’da {what} seçilirse görünür.',
        faithOpen: 'İnanç sorusunda bir seçim yapana kadar gizli. Ayarlar’dan değiştirebilirsin.',
        food: 'Gizlendi, çünkü {rules}. Ayarlar’dan değiştirebilirsin.',
        variant: 'Bu tarifin bir çeşidi listede zaten var.',
        rulePhrase: {
            halal: 'helal yiyorsunuz',
            no_pork: 'domuz eti yemiyorsunuz',
            no_beef: 'sığır eti yemiyorsunuz',
            vegetarian: 'vejetaryen besleniyorsunuz',
            vegan: 'vegan besleniyorsunuz',
            kosher: 'koşer yiyorsunuz',
            no_alcohol: 'alkol kullanmıyorsunuz',
        },
    },
    warning: {
        contains: 'Bunun içinde {ingredient} var.',
        containsMany: 'Bunun içinde {ingredient} var.',
        person: {
            halal: '{names} helal yiyor.',
            no_pork: '{names} domuz eti yemiyor.',
            no_beef: '{names} sığır eti yemiyor.',
            vegetarian: '{names} vejetaryen besleniyor.',
            vegan: '{names} vegan besleniyor.',
            kosher: '{names} koşer yiyor.',
            no_alcohol: '{names} alkol kullanmıyor.',
        },
        people: {
            halal: '{names} helal yiyor.',
            no_pork: '{names} domuz eti yemiyor.',
            no_beef: '{names} sığır eti yemiyor.',
            vegetarian: '{names} vejetaryen besleniyor.',
            vegan: '{names} vegan besleniyor.',
            kosher: '{names} koşer yiyor.',
            no_alcohol: '{names} alkol kullanmıyor.',
        },
        everyone: {
            halal: 'Ailece helal yiyorsunuz.',
            no_pork: 'Ailece domuz eti yemiyorsunuz.',
            no_beef: 'Ailece sığır eti yemiyorsunuz.',
            vegetarian: 'Ailece vejetaryen besleniyorsunuz.',
            vegan: 'Ailece vegan besleniyorsunuz.',
            kosher: 'Ailece koşer yiyorsunuz.',
            no_alcohol: 'Ailece alkol kullanmıyorsunuz.',
        },
        check: 'Dikkat: bunda {what} olabilir.',
        meatDairy: 'Burada et ile süt ürünü bir arada: {meat} ve {dairy}.',
        item: {
            pork: 'İçinde domuz eti var.',
            beef: 'İçinde sığır eti var.',
            meat: 'İçinde et var.',
            fish: 'İçinde balık var.',
            shellfish: 'İçinde kabuklu deniz ürünü var.',
            dairy: 'İçinde süt ürünü var.',
            egg: 'İçinde yumurta var.',
            honey: 'İçinde bal var.',
            gelatin: 'İçinde çoğu zaman domuz jelatini var.',
            alcohol: 'İçinde alkol var.',
        },
        swap: 'İpucu: {ingredient} yerine {swap}.',
        swapButton: 'Değiştir',
        addAnyway: 'Böyle kalsın',
        add: 'Tamam',
        eatsOther: '{name} başka bir şey yiyor',
        whoEats: 'Kimler yiyecek?',
        everyoneEats: 'Herkes',
        and: 've',
    },
    screens: {
        practices: {
            prayer: 'Namaz',
            wudu: 'Abdest almak',
            mosque: 'Cami (dersi)',
            quran: 'Kuran dersi',
            church: 'Kilise',
            shabbat: 'Şabat',
            synagogue: 'Sinagog',
            mandir: 'Mandir',
        },
        noneHint: 'O zaman Namaz ve Cami dersi gibi inanç seçeneklerini gözden kaldırırız.',
        otherFaithHint: 'Namaz görünür kalır; adı geçen inançların seçenekleri görünmez.',
        stepLabel: 'Adım {n} / {total}',
        progress: 'Soru {n} / {total}',
        noConsentYet: 'İzin olmadan hiçbir şey kaydetmeyiz.',
        saved: 'Kaydedildi. Artık sana daha uygun olanı görürsün.',
        savedMember: '{name} için kaydedildi.',
        resetMember: '{name} yine aileyi takip ediyor.',
        savedSelf: 'Kaydedildi.',
        resetSelf: 'Yine aileyi takip ediyorsun.',
        selfWithdrawn: 'Kendi seçimlerin silindi.',
        noChanges: 'Hiçbir şey değişmedi.',
        loadError: 'Bu yüklenemedi.',
        changed: 'Bir şeyi değiştirdin.',
        settingsCardBody: 'Mutfak, inanç, yemek ve özel günler',
        membersTitle: 'Aile üyesi başına',
        membersIntro: 'Aile varsayılandır. Bir aile üyesi farklı olabilir.',
        consentTitle: 'İzin',
        appliesTo: 'Geçerli olduğu kişiler: {list}',
        selfTag: '{name} (kendisi)',
        kidsTag: '{list} (16 yaşından küçük çocuklar)',
        noConsent: 'Henüz izin verilmedi. İlk kaydedişte soracağız.',
        inviteLater: 'Daha sonra tekrar soracağız.',
        inviteNever: 'Tamam. Her zaman Ayarlar’da bulabilirsin.',
        otherParentWhat: 'mutfak, inanç ve yemek',
        dayCount: 'gün {n}/{total}',
        daysOn: 'Açık',
        daysOff: 'Kapalı',
        lessDays: 'Daha az özel gün',
        offeredEmpty: 'Yukarıdan mutfak ya da inanç seç, sana uygun günler önerelim.',
        member: {
            title: 'Değiştir',
            open: '{name} için değiştir',
            faith: 'İnanç',
            food: 'Yemek',
            foodHint: 'Ailenin seçimleri işaretli. Açtığın eklenir, kapattığın {name} için geçerli olmaz. Ailenin sonraki seçimleri kendiliğinden uygulanır.',
            faithFollows: 'İnanç: ailedeki gibi',
            lapsed: '{name} bunu artık kendisi ayarlıyor.',
            selfIntro: 'Bunu kendin için ayarlıyorsun.',
            selfGiven: 'Kendin için izin verdin.',
            withdrawSelfTitle: 'Kendi seçimin silinsin mi?',
            withdrawSelfBody: 'Yeniden aileyi takip edersin. Kendin için ayarladıklarını hemen sileriz.',
            withdrawSelfConfirm: 'Sil',
            save: 'Kaydet',
            linkCopied: 'Bağlantı kopyalandı.',
            notSetYet: 'Önce aileye uygun olanı ayarla ve kaydet. Sonra aile üyesi başına farklılık belirleyebilirsin.',
        },
        self: {
            title: 'Bana uygun olanlar',
            intro: 'Aileden farklı bir inancın ya da beslenmen mi var? Bunu burada kendin ayarlarsın. Sadece sen ve ebeveynlerin görür.',
            parents: 'Bunu annen ve baban ayarlar. 16 yaşından itibaren senin için neyin farklı olduğunu burada kendin belirtebilirsin.',
            notYet: 'Annen ve baban ailene uygun olanları henüz ayarlamadı. Sonra burada kendi seçimlerini yapabilirsin.',
            settingsBody: 'Kendi inancın ve yemeğin',
        },
    },
};
//# sourceMappingURL=profileApp.tr.js.map